<template>
  <v-container fluid>
    <v-slide-y-transition mode="out-in">
      <v-layout column align-center>
        <img src="@/assets/logo.png" height="500px">
      </v-layout>
    </v-slide-y-transition>
  </v-container>
</template>

<script>
    export default {
      name: 'Home'
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/pages/Home.vue